import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=3bcbe14e"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcbe14e')) {
      api.createRecord('3bcbe14e', component.options)
    } else {
      api.reload('3bcbe14e', component.options)
    }
    module.hot.accept("./Video.vue?vue&type=template&id=3bcbe14e", function () {
      api.rerender('3bcbe14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Video.vue"
export default component.exports